import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../../contexts/AuthContext";
import { EditLiveEventSidebar } from "./EditLiveEventSidebar";
import MediaDocs from "./MediaDocs";
import AgentSettings from "./AgentSettings";
import CoreDetails from "./CoreDetails";
import PreviewSidebar from "./PreviewSidebar";
import { BackLink, Button, CancelButton, PageTitle, PageHeader } from "../../../components/StyledElements";
import { getLiveEvent } from "../../../services/liveevents"
import Loading from "../../../components/Loading";
import Swal from "sweetalert2";

import { useLiveEvents } from "../../../contexts/LiveEventsContext";

export const EditLiveEvent = () => {
  const { activeUser } = useAuthContext();
  const isAdmin = activeUser?.user_type.includes("admin");
  const navigate = useNavigate();
  const { event_id } = useParams();
  const [selectedTab, setSelectedTab] = useState(window.location.hash ? window.location.hash.substr(1) : "details");
  const [savingEvent, setSavingEvent] = useState(false);
  const { selectedEvent, setSelectedEvent, setUpdatedEvent, updatedEvent, canSaveEvent, saveUpdatedEvent, saveStatus } = useLiveEvents();
  const [usersInfo, setUsersInfo] = useState({
    users: [],
    userCount: 0,
  });

  console.log("!!! EVENT ID: ", event_id);

  useEffect(() => {
    console.log("!!! USERS INFO UPDATED: ", usersInfo);
  }, [usersInfo]);

  useEffect(() => {
    // Fetch live event details using event_id
    console.log("!!! FETCHING EVENT ID: ", event_id);
    const fetchLiveEvent = async () => {
      const event = await getLiveEvent(event_id, true);
      setSelectedEvent(event);
      setUpdatedEvent(event);

      setUsersInfo({
        users: event.users ?? [],
        userCount: event.user_count ?? 0,
      });
      console.log("!!! LIVE EVENT: ", event);
    };
    if (event_id) {
      fetchLiveEvent();
    } else {
      console.log("!!! NO EVENT ID, SETTING EMPTY UPDATED EVENT");
      setUpdatedEvent({
        public_id: "",
        title: "",
        event_type: "live",
        price: 0.00,
        moderator_agent_instructions: "",
        auto_moderation: true,
        open_date: null,
        start_date: null,
        recording_date: null,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event_id]);

  const saveEvent = async () => {
    if (!canSaveEvent() || savingEvent) {
      return;
    }

    Swal.fire({
      title: "Saving Live Event",
      text: "Please wait while we save your live event details.",
      timerProgressBar: true,
      allowOutsideClick: false,
      onOpen: async () => {
        Swal.showLoading();
        setSavingEvent(true);
        const public_id = await saveUpdatedEvent();
        console.log("!!! PUBLIC ID: ", public_id);
        Swal.close();
        if (public_id) {
          // Update url if it's a new event
          window.history.replaceState(null, null, `/live-event/edit/${public_id}`);
          Swal.fire({
            title: "Live Event Saved",
            text: "Your live event has been saved successfully.",
            icon: "success",
          });
        } else {
          Swal.fire({
            title: "Error Saving Live Event",
            text: "There was an error saving your live event. Please try again.",
            icon: "error",
          });
        }
        setSavingEvent(false);
      },
    });
  }

  if (!selectedEvent && event_id) {
    return <Loading>Loading Live Event...</Loading>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)" }}>
      <div style={{ width: "250px" }}>
        <EditLiveEventSidebar
          liveEventId={updatedEvent?.public_id}
          defaultSelectedTab={selectedTab}
          onNavItemClicked={(navItem) => {
            console.log("!!! NAV ITEM CLICKED: ", navItem);
            setSelectedTab(navItem);
          }}
        />
      </div>
      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          width: `calc(100% - 250px)`,
          minHeight: "calc(100vh - 40px)",
          position: "relative",
          backgroundColor: "var(--content-item-bg)",
          padding: "20px",
          borderRadius: "8px",
          color: "var(--main-font-color)",
          zIndex: 1,
          /*height: "2000px",*/
        }}
      >
        <PageHeader style={{ position: "sticky", top: "0px", backgroundColor: "var(--content-item-bg)", zIndex: 2, display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
          <div>
            <BackLink onClick={() => {
              if (false && activeUser?.user_type.match(/client/)) {
                navigate(`/client/live-events`);
              } else {
                navigate(`/live-events`);
              }
            }} >
              <i className="fa fa-arrow-left" /> Back to Live Events</BackLink>
            <PageTitle title={`${updatedEvent?.id ? "Edit" : "New"} Live Event`} style={{ marginBottom: "0px" }} />
            {updatedEvent?.title ?
              <PageTitle title={updatedEvent?.title} style={{ marginBottom: "10px", fontWeight: "500", fontSize: "20px" }} />
              : null}
          </div>
          {
            isAdmin && (
              <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
                <CancelButton onClick={() => {
                  setUpdatedEvent(selectedEvent);
                }}>Cancel</CancelButton>
                <Button disabled={!canSaveEvent() || savingEvent} onClick={saveEvent} style={{ marginLeft: "auto" }}>{savingEvent ? "Saving Changes" : "Save Changes"}</Button>
              </div>
            )}
        </PageHeader>

        {saveStatus && saveStatus !== "completed" ?
          <PageHeader style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            {saveStatus}
          </PageHeader>
          : null}


        <div style={{ backgroundColor: "var(--content-item-bg)", marginTop: "20px", marginBottom: "40px" }}>
          <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <div style={{ width: "66%" }}>
              <CoreDetails
                style={{ display: selectedTab === "details" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <MediaDocs style={{ display: selectedTab === "media-docs" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <AgentSettings style={{ display: selectedTab === "agent-settings" ? "flex" : "none" }} />
            </div>
            <div style={{ width: "34%" }}>
              <PreviewSidebar users={usersInfo.users} userCount={usersInfo.userCount} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditLiveEvent;
